import { defineMessages } from 'react-intl';

export default defineMessages({
  bookingButton: {
    id: 'experienceInfo.bookingButton',
    defaultMessage: 'choose date & time',
  },
  descriptionTitle: {
    id: 'experienceInfo.descriptionTitle',
    defaultMessage: "what you'll do",
  },
  weProvideTitle: {
    id: 'experienceInfo.weProvideTitle',
    defaultMessage: 'we provide',
  },
});
